export enum InvoiceStatus {
  DRAFT = "draft",
  OPEN = "open",
  PAID = "paid",
  VOID = "void",
  UNCOLLECTABLE = "uncollectable",
}

export interface Invoice {
  finalized_at: string | null;
  receipt_url: string;
  description: string;
  total: number;
  status: InvoiceStatus;
  id: string;
  subscription_id: boolean;
}
